export default __webpack_public_path__ + "static/media/q27_step5.305cc778.png";